export enum PublisherType {
  CIS = 'CIS',
  CONTROLS = 'CONTROLS',
  CUSTOM = 'Custom (Agent-Based)',
  CUSTOM_CONSOLE = 'Custom (Engine-Based)',
  DISASTIGS = 'DISASTIGS',
  FDCC = 'FDCC',
  USGCB = 'USGCB',
}
